import { logger } from "c7-logger";

import { sendCustomAction } from "datadog-loader/loader";

import {
  Announcement,
  AnnouncementCallback,
  PubSub,
  Subscribe,
  Subscribers,
} from "./types";

const pubSub = (): PubSub => {
  let subscribers: Subscribers = [];

  const subscribe: Subscribe = (
    merchantSubscriberCallback?: AnnouncementCallback
  ) => {
    if (
      !merchantSubscriberCallback ||
      typeof merchantSubscriberCallback !== "function"
    ) {
      logger.error("Please provide a valid callback");

      // Datadog
      sendCustomAction({
        name: "pubSub subscribe merchantSubscriberCallback error",
        context: {
          message: "Please provide a valid callback",
        },
      });

      return () => undefined;
    }

    const wrappedSubscriber = watchCbForErrors(merchantSubscriberCallback);

    subscribers.push(wrappedSubscriber);

    return () => unsubscribe(wrappedSubscriber);
  };

  const unsubscribe = (merchantSubscriberCallback: AnnouncementCallback) => {
    const length = subscribers.length;
    subscribers = subscribers.filter(
      (item: AnnouncementCallback) => item !== merchantSubscriberCallback
    );

    sendCustomAction({
      name: `pubSub Unsubscribe Called`,
      context: {
        level: "info",
        namespace: "pubSub",
        message: `Unsubscribed from ${length} to ${subscribers.length} subscribers`,
        numberOfSubscribers: `${subscribers.length ?? "0"}`,
      },
    });

    return length > subscribers.length;
  };

  const watchCbForErrors =
    (callback: AnnouncementCallback) => (message: Announcement) => {
      try {
        callback(message);
      } catch (error: unknown) {
        if (error instanceof Error) {
          logger.error(error.message);

          // Datadog
          sendCustomAction({
            name: "pubSub watchCbForErrors Error",
            context: {
              message: error.message,
            },
          });
        } else {
          logger.error(String(error));

          // Datadog
          sendCustomAction({
            name: "pubSub watchCbForErrors error",
            context: {
              message: String(error),
            },
          });
        }
      }
    };

  const publish = (message: Announcement) => {
    subscribers.forEach((subscriber: AnnouncementCallback) =>
      subscriber(message)
    );

    // don't send debug messages to datadog
    if (message.level !== "debug") {
      // Datadog
      sendCustomAction({
        name: `pubSub publish ${message.message}`,
        context: {
          level: message.level,
          namespace: message.namespace,
          message: message.message,
          numberOfSubscribers: `${subscribers.length ?? "0"}`,
          instanceId: message.payload?.instanceId ?? undefined,
        },
      });
    }
  };

  const getSubscribers = () => subscribers;

  const clearAllSubscribers = () => {
    subscribers = [];
    // Datadog
    sendCustomAction({
      name: `pubSub all subscribers cleared`,
    });
  };

  return {
    subscribe,
    publish,
    getSubscribers,
    clearAllSubscribers,
  };
};

export default pubSub;
